<template>
  <el-dialog
    :title="type === 'edit'?'编辑':'新增'"
    :visible.sync="dialog"
    :width="getIsMobile?'100%':'60%'"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="handleClose"
  >
    <el-form ref="formRef" :model="form" label-width="100px" label-position="right" :rules="rules" class="custom-form">
      <el-form-item label="型号" prop="xhname">
        <el-input v-model="form.xhname" placeholder="请输入型号"></el-input>
      </el-form-item>
      <el-form-item label="品牌" prop="source">
        <el-input v-model="form.source" placeholder="请输入品牌"></el-input>
      </el-form-item>
      <el-form-item label="产地" prop="address">
        <el-input v-model="form.address" placeholder="请输入产地"></el-input>
      </el-form-item>
      <el-form-item label="包装" prop="baozhuang">
        <el-input v-model="form.baozhuang" placeholder="请输入包装"></el-input>
      </el-form-item>
      <el-form-item label="备注" prop="beizhu">
        <el-input v-model="form.beizhu" placeholder="请输入备注"></el-input>
      </el-form-item>
      <el-form-item label="供应商" prop="gongyingshang">
        <el-input v-model="form.gongyingshang" placeholder="请输入供应商"></el-input>
      </el-form-item>
      <el-form-item label="库存数量" prop="number">
        <el-input v-model.number="form.number" placeholder="请输入库存数量"></el-input>
      </el-form-item>
      <el-form-item label="未税价格" prop="wshui">
        <el-input v-model.number="form.wshui" placeholder="请输入未税价格"></el-input>
      </el-form-item>
      <el-form-item label="含税价格" prop="hshui">
        <el-input v-model.number="form.hshui" placeholder="请输入含税价格"></el-input>
      </el-form-item>
      <el-form-item label="库房货位" prop="kufang">
        <el-input v-model="form.kufang" placeholder="请输入库房货位"></el-input>
      </el-form-item>
      <el-form-item label="自定义价格" prop="zdyprice">
        <el-input v-model.number="form.zdyprice" placeholder="请输入自定义价格"></el-input>
      </el-form-item>
      <el-form-item label="收票发票号" prop="spfph">
        <el-input v-model="form.spfph" placeholder="请输入收票发票号"></el-input>
      </el-form-item>
      <el-form-item label="进货日期" prop="settime">
        <el-date-picker
          class="custom-date-picker"
          v-model="form.settime"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="选择日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="收票状态" prop="spzt">
        <el-radio-group v-model="form.spzt">
          <el-radio :label="0">未税</el-radio>
          <el-radio :label="1">已到</el-radio>
          <el-radio :label="2">未到</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="商品名称" prop="title">
        <el-radio-group v-model="form.title">
          <el-radio label="配件">配件</el-radio>
          <el-radio label="密封件">密封件</el-radio>
          <el-radio label="丝杆螺母">丝杆螺母</el-radio>
          <el-radio label="导轨滑块">导轨滑块</el-radio>
          <el-radio label="油脂">油脂</el-radio>
          <el-radio label="轴承">轴承</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="合同状态" prop="zt">
        <el-radio-group v-model="form.zt">
          <el-radio :label="1">开放</el-radio>
          <el-radio :label="0">锁定</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleReset">重 置</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="submitLoading">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { defineComponent, reactive, ref, watch } from '@vue/composition-api'
import useRootSetting from '@/hooks/useRootSetting'
export default defineComponent({
  components: {},
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: ''
    },
    formData: {
      type: Object,
      default: () => {
      }
    },
    submitLoading: {
      type: Boolean,
      default: false
    }
  },
  setup(props, { emit }) {
    const { getIsMobile } = useRootSetting()
    const formRef = ref(null)
    const rules = {
      xhname: [
        { required: true, message: '型号不能为空', trigger: 'blur' }
      ],
      source: [
        { required: true, message: '品牌不能为空', trigger: 'blur' }
      ],
      address: [
        { required: true, message: '产地不能为空', trigger: 'blur' }
      ],
      baozhuang: [
        { required: true, message: '包装不能为空', trigger: 'blur' }
      ],
      number: [
        { required: true, message: '库存数量不能为空', trigger: 'blur' },
        { type: 'number', message: '库存数量必须为数字值'}
      ],
      beizhu: [
        { required: true, message: '备注不能为空', trigger: 'blur' }
      ],
      gongyingshang: [
        { required: true, message: '供应商不能为空', trigger: 'blur' }
      ],
      wshui: [
        { required: true, message: '未税价格不能为空', trigger: 'blur' },
        { type: 'number', message: '未税价格必须为数字值'}
      ],
      hshui: [
        { required: true, message: '含税价格不能为空', trigger: 'blur' },
        { type: 'number', message: '含税价格必须为数字值'}
      ],
      kufang: [
        { required: true, message: '库房货位不能为空', trigger: 'blur' }
      ],
      zdyprice: [
        { required: true, message: '自定义价格不能为空', trigger: 'blur' },
        { type: 'number', message: '自定义价格必须为数字值'}
      ],
      spfph: [
        { required: true, message: '收票发票号不能为空', trigger: 'blur' }
      ],
      settime: [
        { required: true, message: '进货日期不能为空', trigger: 'change' }
      ],
      spzt: [
        { required: true, message: '收票状态不能为空', trigger: 'blur' }
      ],
      title: [
        { required: true, message: '商品名称不能为空', trigger: 'blur' }
      ],
      zt: [
        { required: true, message: '合同状态不能为空', trigger: 'change' }
      ]
    }


    const form = reactive({
      xhname: '',
      source: '',
      address: '',
      baozhuang: '',
      number: '',
      beizhu: '',
      gongyingshang: '',
      wshui: '',
      hshui: '',
      kufang: '',
      zdyprice: '',
      spfph: '',
      settime: '',
      spzt: '',
      title: '',
      zt:1
    })

    watch(()=> props.formData, (val)=> {
      if (!val || typeof val !== 'object') return;
      Object.keys(val).forEach((key) => {
        if (key in form) {
          const value = val[key];

          // 判断 value 是否为字符串形式的纯数字
          form[key] = typeof value === 'string' && !isNaN(value)
            ? Number(value)
            : value;
        }
      });
    },{deep:true})

    const handleReset = () => formRef.value.resetFields()
    const handleSubmit = () => {
      formRef.value.validate(valid => {
        if (valid) {
          emit('submit', form)
        }
      })
    }
    const handleClose = () => emit('close')

    return {
      getIsMobile,
      formRef,
      form,
      rules,
      handleReset,
      handleSubmit,
      handleClose
    }
  }
})
</script>
<style scoped>
.custom-form {
  max-height: 600px;
  overflow-y: scroll;
}
</style>
